// Generated by purs version 0.13.8
"use strict";
var Control_Apply = require("../Control.Apply/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var $$with = function (dictFunctor) {
    return Data_Function.flip(Data_Functor.map(dictFunctor));
};
var composeMap = function (dictFunctor) {
    return function (dictFunctor1) {
        var $5 = Data_Functor.map(dictFunctor);
        var $6 = Data_Functor.map(dictFunctor1);
        return function ($7) {
            return $5($6($7));
        };
    };
};
var composeApply = function (dictApplicative) {
    return function (dictApplicative1) {
        return Control_Apply.lift2(dictApplicative.Apply0())(Control_Apply.apply(dictApplicative1.Apply0()));
    };
};
module.exports = {
    "with": $$with,
    composeMap: composeMap,
    composeApply: composeApply
};
//# sourceMappingURL=index.js.map
